import { z } from "zod";
import { AssignableRoleSchema } from "../../users/schemas/assign-role.schema.js";

export const OnboardingLanguageSchema = z.enum(["en", "fr-CA", "es-419"]);
export type OnboardingLanguage = z.infer<typeof OnboardingLanguageSchema>;

export const OnboardUserSchema = z
  .object({
    email: z.email(),
    orgId: z.string().min(1).optional(),
    role: AssignableRoleSchema.optional(),
    language: OnboardingLanguageSchema,
  })
  .strict()
  .refine((v) => v.orgId === undefined || v.role !== undefined, {
    path: ["role"],
    message: "A role is required when a client is selected",
  })
  .describe("role is required whenever orgId is present");

export type OnboardUserBody = z.infer<typeof OnboardUserSchema>;

export const OnboardingResponseSchema = z
  .object({
    id: z.string().min(1),
    email: z.email(),
  })
  .strict();

export type OnboardingResponse = z.infer<typeof OnboardingResponseSchema>;
